/**
 * Moduł otwiera w oknie modalnym etykietę gwarancji trwałości
 */
app.service('durabilityGuaranteeLayer', function (simpleModal, modal) {

	function setEvents() {
		$('body').on('click', '.js-durability-guarantee', function () {
			modal.close();
			simpleModal.generate({
				content: '<h2>' + $(this).data('header') + '</h2><img src="' + $(this).data('img') + '" alt="' + ($(this).data('alt') || '') + '" />',
				classList: 'durability-guarantee-modal'
			});
		});
	}

	function init() {
		setEvents();
	}

	return {
		init
	};
});
